import PlaygroundAuthType from "../../../playgroundAuthType";
import sanitizeName from "./sanitizeName";
import OAUTH_NOTE from "./oauthNote";

const getClaudeDesktopInstructions = (
  playground,
  bearerToken,
  mcpServerUrl
) => {
  const oauthNote =
    playground.authType === PlaygroundAuthType.OAUTH ? OAUTH_NOTE : "";
  let codeSnippet = `{
  "mcpServers": {
    "${sanitizeName(playground.name)}": {
      "command": "npx",
      "args": ["mcp-remote", "${mcpServerUrl}"]
    }
  }
}`;

  if (playground.authType === "BEARER_TOKEN") {
    codeSnippet = `{
  "mcpServers": {
    "${sanitizeName(playground.name)}": {
      "command": "npx",
      "args": [
        "mcp-remote",
        "${mcpServerUrl}",
        "--header",
        "Authorization:\${AUTH_HEADER}"
      ],
      "env": {
        "AUTH_HEADER": "Bearer ${bearerToken ? bearerToken : "<YOUR_API_KEY>"}"
      }
    }
  }
}`;
  }

  return `

${oauthNote}If you've previously configured MCP servers, add the code snippet below to the claude_desktop_config.json file. Otherwise, see the next section for detailed instructions.

\`\`\`json
${codeSnippet}
\`\`\`

## 1. Download Claude Desktop

Start by [downloading Claude for Desktop](https://claude.ai/download), choosing either macOS or Windows. (Linux is not yet supported for Claude for Desktop.) 

Follow the installation instructions.

If you already have Claude for Desktop, make sure it's on the latest version by clicking on the Claude menu on your computer and selecting “Check for Updates…“

## 2. Add the MCP Server

Get started by opening up the Claude menu on your computer and select “Settings…” Please note that these are not the Claude Account Settings found in the app window itself. 

This is what it should look like on a Mac:

![](/app/images/screens/claude_desktop_config_1.webp)


Click on “Developer” in the left-hand bar of the Settings pane, and then click on “Edit Config”:

![](/app/images/screens/claude_desktop_config_2.webp)

This will create a configuration file at:
- macOS: \`/Users/[user]/Library/Application Support/Claude/claude_desktop_config.json\`
- Windows: \`%APPDATA%\\Claude\\claude_desktop_config.json\`

Open up the configuration file in any text editor. Replace the file contents with this:

\`\`\`json
${codeSnippet}
\`\`\`

## 3. Restart Claude

After updating your configuration file, you need to restart Claude for Desktop. Upon restarting, you should see a slider icon in the bottom left corner of the input box:

![filter](https://mintlify.s3.us-west-1.amazonaws.com/mcp/images/quickstart-slider.png)

After clicking on the slider icon, you should see the tools that come with the MCP Server.

You can now talk to Claude and it should know when to call the relevant tools 🎉.


If you get an error saying “command not found” or “node is not recognized”, download Node from [nodejs.org](https://nodejs.org/en/download).

For further details, see [the official documentation here](https://modelcontextprotocol.io/quickstart/user).


`;
};

export default getClaudeDesktopInstructions;
